var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { usePopper } from 'react-popper';
import { BodyPortal } from '../BodyPortal';
import * as S from './styles';
export var Popper = function (_a) {
    var referenceElement = _a.referenceElement, children = _a.children, placement = _a.placement, containerWidth = _a.containerWidth, onClose = _a.onClose, _b = _a.open, open = _b === void 0 ? true : _b;
    var _c = useState(null), popperElement = _c[0], setPopperElement = _c[1];
    var _d = usePopper(referenceElement, popperElement, {
        placement: placement,
        strategy: 'absolute',
    }), styles = _d.styles, attributes = _d.attributes;
    if (!open)
        return null;
    return (_jsx(BodyPortal, { children: _jsx(S.Container, __assign({ onClick: onClose }, { children: _jsx(S.Wrapper, __assign({ ref: setPopperElement, style: __assign(__assign({}, styles.popper), (containerWidth && {
                    width: "".concat(referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.offsetWidth, "px"),
                })) }, attributes.popper, { onClick: function (e) { return e.stopPropagation(); } }, { children: children })) })) }));
};
